/**
 * Legal / privacy constants for CyberTracer.ro.
 */

export const LEGAL_POLICY_VERSION = '2026-10-02';
export const COOKIE_POLICY_VERSION = '2026-10-02';

/** Draft controller — replace after DPO confirmation. */
export const LEGAL_CONTROLLER = {
  productName: 'CyberTracer.ro',
  siteUrl: 'https://cybertracer.ro',
  /** Legal entity operating the service. */
  legalName: 'SMART CHOICE SRL',
  tradeName: 'CyberTracer / Cyber Tech',
  email: 'cybertech@smartchoice.ro',
  cui: 'RO 17491492',
  registeredAddress:
    'Iasi, Nicolae Iorga Boulevard no. 8, Block 901A, ground floor Postal Code 700212',
  dpoEmail: 'cybertech@smartchoice.ro',
  supervisoryAuthority: {
    name: 'ANSPDCP — Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal',
    url: 'https://www.dataprotection.ro',
  },
};

/** Retention windows documented for users and operators (days unless noted). */
export const LEGAL_RETENTION = {
  osintResultCacheHours: 24,
  dnsWhoisCacheDays: 7,
  preprocessCacheHours: 12,
  adminLastSearchesDays: 90,
  adminHtopHours: 24,
  clientSearchTraceHours: 24,
  nginxAccessLogsDays: '30–90 (host / container logging policy)',
  consentEvidenceLocal: 'Until withdrawn or cleared by the user',
};
